import { getLegendStyle } from '../../theme/common/legend';
import merge from 'lodash.merge';
import cloneDeep from 'lodash.clonedeep';
import { isType } from '../../utils/util'; // 没有legend时的半径与有legend时的半径比

var widthLegendRatio = 1.166; // 通过媒体查询来设置legend的位置

var mediaOption = [{
  option: {
    legend: {
      top: 'auto'
    }
  }
}, {
  query: {
    minWidth: 500,
    maxWidth: 699
  },
  option: {
    legend: {
      top: '5%'
    }
  }
}, {
  query: {
    minWidth: 700,
    maxWidth: 999
  },
  option: {
    legend: {
      top: '9%'
    }
  }
}, {
  query: {
    minWidth: 1000
  },
  option: {
    legend: {
      top: '11%'
    }
  }
}];

var getRadarTitle = function getRadarTitle(config, theme) {
  return {
    top: 'center',
    left: 'center',
    textStyle: {
      color: theme.color[0],
      fontSize: 10,
      fontWeight: 'normal'
    },
    subtextStyle: {
      color: theme.color[0],
      fontSize: 20,
      fontWeight: 'bold'
    }
  };
};

var getRadarLegend = function getRadarLegend(config, _ref) {
  var legend = _ref.legend;
  if (!legend) return;
  return getLegendStyle();
};

var getRadarTooltip = function getRadarTooltip(config) {
  return {};
};

var getRadarRadar = function getRadarRadar(config, _ref2) {
  var legend = _ref2.legend;
  var radar = {
    center: ['50%', '56%'],
    radius: '60%'
  };

  if (!legend) {
    radar.center[1] = '50%';
    radar.radius = parseFloat(radar.radius) * widthLegendRatio + '%';
  }

  return radar;
};

var getRadarSeries = function getRadarSeries(config, series, theme) {
  series.forEach(function (chart, idx) {
    if (!isType(chart, 'radar')) return;

    if (config.showArea) {
      chart.areaStyle = {
        color: theme.color[idx],
        opacity: 0.1
      };
    }
  });
  return series;
};

export default function (config) {
  if (config === void 0) {
    config = {};
  }

  return function (options, theme) {
    var title = getRadarTitle(config, theme);
    var legend = getRadarLegend(config, options);
    var radar = getRadarRadar(config, options);
    var tooltip = getRadarTooltip(config);
    var series = getRadarSeries(config, cloneDeep(options.series), theme);
    var baseOption = merge({
      title: title,
      tooltip: tooltip,
      legend: legend,
      radar: radar,
      series: series
    }, options);

    if (options.legend && !options.legend.top && !options.legend.bottom) {
      return {
        baseOption: baseOption,
        media: mediaOption
      };
    } else {
      return baseOption;
    }
  };
}